<template>
  <div class="patient-not-listed-card px-5 py-3 flex flex-col items-center justify-center">
    <p class="question-text">Patient not listed?</p>
    <Button class="mt-1" color-type="none-stroke" style-text="font-family: Roboto;" @click="$emit('click')">
      Search patient or Create New
    </Button>
  </div>
</template>

<script>
import Button from "@/NewLibrary/Button.vue";
export default {
  emits: ['click'],
  components: {
    Button
  }
}
</script>

<style scoped>
.patient-not-listed-card {
  border-radius: 4px;
  border: 1px solid #E6E6E6;
  background: #FFFFFF;
}

.patient-not-listed-card:hover {
  border-radius: 4px;
  border: 1px solid #1E4670;
  background: #FFFDFC;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.19);
  transition: border-color 0.2s ease;
}

.question-text {
  color: #333333;
  font-weight: 500;
}
</style>
